"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AppInsightsProvider = require("./AppInsightsProvider");
Object.keys(_AppInsightsProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppInsightsProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AppInsightsProvider[key];
    }
  });
});
var _ErrorBoundary = require("./ErrorBoundary");
Object.keys(_ErrorBoundary).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorBoundary[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorBoundary[key];
    }
  });
});
var _LoggerProvider = require("./LoggerProvider");
Object.keys(_LoggerProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoggerProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoggerProvider[key];
    }
  });
});
var _useLogger = require("./useLogger");
Object.keys(_useLogger).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useLogger[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useLogger[key];
    }
  });
});
